var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17892 1.02058V3.15868H8.81892V1.02058L2.79297 3.74578V8.55568C2.79297 12.2133 5.50272 14.9709 8.81892 16.9789V13.9582H9.17892V16.9789C12.4963 14.9709 15.2061 12.2133 15.2061 8.55568V3.74578L9.17892 1.02058ZM8.99927 12.7887C6.64591 12.7887 4.73836 10.881 4.73836 8.52778C4.73836 6.17458 6.64606 4.26748 8.99927 4.26748C11.3522 4.26748 13.2596 6.17443 13.2596 8.52778C13.2596 10.8811 11.3526 12.7887 8.99927 12.7887Z",
    fill: "url(#paint0_linear_7212_35765)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00077 4.88264C6.98732 4.88264 5.35547 6.51449 5.35547 8.52839C5.35547 10.5415 6.98732 12.1741 9.00077 12.1741C11.0139 12.1741 12.6468 10.5415 12.6468 8.52839C12.6465 6.51494 11.0135 4.88264 9.00077 4.88264ZM9.28518 10.4601V11.1034H8.66597V10.5043C8.24298 10.4852 7.83329 10.3715 7.59282 10.2322L7.7829 9.49451C8.04786 9.63924 8.4201 9.77171 8.83085 9.77171C9.19085 9.77171 9.43706 9.63314 9.43706 9.38002C9.43706 9.14095 9.23474 8.98909 8.76744 8.83141C8.0921 8.60423 7.63131 8.28889 7.63131 7.67653C7.63131 7.12106 8.02266 6.68506 8.69871 6.55258V5.95316H9.31682V6.50863C9.7398 6.52773 10.0242 6.61591 10.2323 6.71705L10.0487 7.4302C9.88488 7.36071 9.59438 7.21528 9.14045 7.21528C8.73006 7.21528 8.59688 7.39205 8.59688 7.56877C8.59688 7.77649 8.81831 7.90931 9.35502 8.11163C10.1056 8.37659 10.4087 8.72365 10.4087 9.29171C10.4084 9.85387 10.0109 10.3333 9.28518 10.4601V10.4601Z",
    fill: "url(#paint1_linear_7212_35765)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7212_35765",
    x1: 1.98612,
    y1: 21.7664,
    x2: 19.9467,
    y2: 16.9073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7212_35765",
    x1: 4.88153,
    y1: 14.3616,
    x2: 14.9818,
    y2: 10.8487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafePayment);
export default __webpack_public_path__ + "static/media/safe-payment.13b3c0bd1e55a1322b5c58d71e9b8a06.svg";
export { ForwardRef as ReactComponent };